import { useContext } from "react";
import { sessionContext } from "@/providers/session-provider";

export const useSession = () => useContext(sessionContext);
